<ng-container *ngIf="productRequest">
    <div class="capsule" [class.complete]="(productRequest | approvedProductRequestItemCount) === productRequest.items.length">
        {{ productRequest | approvedProductRequestItemCount }}/{{ productRequest.items.length }} Approved
    </div>
</ng-container>